import { HttpClient } from '../HttpClient';
/**
 * * Post Projects
 */
export const PostProjects = async (projects) => {
  try {
    const { data } = await HttpClient.post('api/projects', { ...projects });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
